import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";
import { CommonService } from "../service/common";
import { API } from "../config/api-config";

@Component({
  selector: "app-experience-params-edit",
  templateUrl: "./experience-params-edit.component.html",
  styleUrls: ["./experience-params-edit.component.css"],
})
export class ExperienceParamsEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public data: any = {
    active: 1,
    id: 0,
    ranks: 0,
    titleEn: "",
    titleTc: "",
    type: 2,
  };

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }

  private getData(): void {
    this.HttpService.getData(API.experienceParams + "/" + this.id).then(
      (res) => {
        this.data = res.data;
      }
    );
  }

  public submit(): void {
    let data = this.data;
    console.log(data);
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.experienceParams, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/experience-params-edit/experience-params-edit.component.ts